export const NOTICES = [
  { value: "MPr-2025-16", label: "MPr-2025-16 | Internacionalização das PME" },
];

export const convertJsonData = (toConvert) => {
  if (Array.isArray(toConvert))
    return toConvert.map((v) => ({ _id: v.value, label: v.label }));

  return Object.entries(toConvert).reduce((acc, [k, arr]) => {
    acc[k] = arr.map((v) => ({ _id: v.value, label: v.label }));
    return acc;
  }, {});
};

export function getProjectYearWeights(projectStartDate, projectEndDate) {
  if (!projectStartDate || !projectEndDate) return {};

  const [sy, sm] = projectStartDate.split("-").map(Number);
  const [ey, em] = projectEndDate.split("-").map(Number);
  if (!sy || !sm || !ey || !em) return {};

  const startIdx = sy * 12 + (sm - 1);
  const endIdx = ey * 12 + (em - 1);
  if (endIdx < startIdx) return {};

  // total de meses no projeto
  const totalMonths = endIdx - startIdx + 1;

  const weights = {};
  for (let y = sy; y <= ey; y++) {
    const yearStart = y * 12;
    const yearEnd = y * 12 + 11;

    const overlapStart = Math.max(startIdx, yearStart);
    const overlapEnd = Math.min(endIdx, yearEnd);
    const overlapMonths = Math.max(0, overlapEnd - overlapStart + 1);

    if (overlapMonths > 0) {
      weights[String(y)] = overlapMonths / totalMonths;
    }
  }

  return weights;
}

export function deepClone(obj) {
  if (typeof structuredClone === "function") return structuredClone(obj);
  return JSON.parse(JSON.stringify(obj));
}
